import React, { useState } from "react"
import { Col, Form, Button } from "react-bootstrap"
import { BiMailSend } from "react-icons/bi"
// import addToMailchimp from "gatsby-plugin-mailchimp"

const EmailSignUp = () => {
  const initialState = {
    firstname: "",
    lastname: "",
    email: "",
  }

  const [formData, setFormData] = useState(initialState)
  const [validated, setValidated] = useState(false)

  const onChange = e =>
    setFormData({ ...formData, [e.target.name]: e.target.value })

  const onSubmit = e => {
    e.preventDefault()
    const form = e.currentTarget
    if (form.checkValidity() !== false) {
      // addToMailchimp()
    }
    setValidated(true)
  }

  return (
    <Form noValidate validated={validated} onSubmit={onSubmit}>
      <Form.Row>
        <Form.Group as={Col} lg="6" controlId="formGroupEmail">
          <Form.Control
            required
            placeholder="First name"
            name="firstname"
            onChange={onChange}
          />
          <Form.Control.Feedback type="invalid">
            Please enter your first name.
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} lg="6" controlId="formGroupEmail">
          <Form.Control
            required
            placeholder="Last name"
            name="lastname"
            onChange={onChange}
          />
          <Form.Control.Feedback type="invalid">
            Please enter your last name.
          </Form.Control.Feedback>
        </Form.Group>
      </Form.Row>
      <Form.Row className="align-items-center">
        <Form.Group as={Col} lg="6" controlId="formGroupEmail">
          <Form.Control
            required
            placeholder="Email"
            onChange={onChange}
            type="email"
            name="email"
          />
          <Form.Control.Feedback type="invalid">
            Please enter your email.
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} lg="auto" controlId="formGroupEmail">
          <Button type="submit" variant="powder" block>
            Sign me up
            <BiMailSend className="ml-2" />
          </Button>
        </Form.Group>
      </Form.Row>
    </Form>
  )
}

export default EmailSignUp
